let _wq;
const URL = "https://fast.wistia.com/assets/external/E-v1.js";

const embedScripts = () => {
  const script = document.createElement("script");
  script.src = URL;
  script.async = true;

  document.body.appendChild(script);
};

export const load = cb => {
  if (window._wq !== undefined) return cb(window._wq);

  window._wq = [];
  embedScripts();
};

export const embedVideo = (handle, cb) => {
  window._wq.push({ id: handle, onReady: cb });
};



// WEBPACK FOOTER //
// ./src/assets/js/wistia.js